// This icon file is generated automatically.
var FilterFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 24 24", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M2.9 3a.9.9 0 00-.69 1.5l7.06 8.34v5.61c0 .35.2.66.5.82l3.64 1.82a.9.9 0 001.32-.82v-7.43l7.06-8.34a.9.9 0 00-.7-1.5H2.91z" } }] }, "name": "filter", "theme": "filled" };
export default FilterFilled;
